import styles from "./SubmitTicketScreen.style";

export default styles;
